
<script setup>
  
  import { reactive, computed } from 'vue';

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { posterThemes, posterTheme, posterStyle } from '../stores/activity-5.js';

  import SaveNotice from '../partials/save-notice.vue';

  import EyeIcon from '../icons/eye-icon.vue';

  import ImageIcon from '../icons/image-icon.vue';

  import EdIcon from '../icons/ed-icon.vue';

  import PosterStyle1 from '../partials/activity-5-poster-style-1.vue';

  import PosterStyle2 from '../partials/activity-5-poster-style-2.vue';

  import PosterStyle3 from '../partials/activity-5-poster-style-3.vue';

  import backgroundPath from '../images/wood-background.jpg';

  const theme = computed( () => reactive( posterThemes.find( ( { id } ) => id === posterTheme.value ) ) );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-4xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Step 4</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Create Your Panel</div>

          </h2>

          <h3 class="mt-8 font-bold text-2xl uppercase">How-To</h3>

          <h4 class="mt-8 text-xl font-semibold font-serif italic">Adding Words and Images</h4>

          <p class="max-w-xl mt-2 leading-7 text-neutral-700">

            You can type directly into text areas.

            Click on the plus icon "(+)" to add a photo to each empty photo box.

            To replace an image, click the plus icon "(+)" again and choose a new image.

          </p>

          <h4 class="mt-8 text-xl font-semibold font-serif italic">Need to Change Your Theme?</h4>

          <p class="max-w-xl mt-2 leading-7 text-neutral-700">

            You can click the "BACK" button at any time to return to the "Choose a Theme" page.

          </p>

          <hr class="h-[2px] mt-12 border-0 bg-neutral-400" />

          <h3 class="mt-12 font-bold text-2xl uppercase">TIPS</h3>

          <ul class="flex flex-col space-y-8 mt-6 max-w-sm">

            <li class="flex items-center gap-8">

              <EyeIcon class="shrink-0 w-12 text-green-700" />

              <div class="font-bold">Write an eye-catching title to entice people to read more.</div>

            </li>

            <li class="flex items-center gap-8">

              <ImageIcon class="shrink-0 w-12 text-green-700" />

              <div class="font-bold">Pick photos that match the theme you chose.</div>

            </li>

            <li class="flex items-center gap-8">

              <EdIcon class="shrink-0 w-12 text-green-700" />

              <div class="font-bold">Remember, your goal is to educate and inspire!</div>

            </li>

          </ul>

          <hr class="h-[2px] mt-12 border-0 bg-neutral-400" />

          <div class="mt-12">

            <div class="p-8 bg-black/5">

              <h3>

                <div class="text-semibold uppercase">Your Theme:</div>

                <div class="text-xl font-bold">{{ theme.label }}</div>

              </h3>

              <PosterStyle1 v-if="posterStyle === 1" />

              <PosterStyle2 v-if="posterStyle === 2" />

              <PosterStyle3 v-if="posterStyle === 3" />

            </div>

          </div>

          <SaveNotice class="max-w-xl mt-12" />

          <div class="flex flex-wrap justify-between gap-6 mt-12">

            <RouterLink
            
              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                  
                hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"

              to="/activity/5/step/3">
              
              <ArrowLeftCircleIcon class="w-8" />

              <span>Back</span>
            
            </RouterLink>

            <RouterLink

              class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
              
                hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
            
              to="/activity/5/preview">
              
              <span>Preview</span>

              <ArrowRightCircleIcon class="w-8" />
            
            </RouterLink>

          </div>

        </div>

      </div>

    </div>

  </article>

</template>
